import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const NotificationsContext = createContext({ unread: 0, items: [], markRead: async () => {}, refresh: () => {} });

export function NotificationsProvider({ children }) {
  const { user, profile } = useAuth();
  const [state, setState] = useState({ unread: 0, items: [] });

  const refresh = useCallback(() => {
    if (!user || !profile) return setState({ unread: 0, items: [] });
    api.get("/notifications").then((r) => setState(r.data)).catch(() => {});
  }, [user, profile]);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 60000);
    return () => clearInterval(id);
  }, [refresh]);

  const markRead = async () => {
    if (!state.unread) return;
    await api.post("/notifications/read").catch(() => {});
    setState((s) => ({ unread: 0, items: s.items.map((n) => ({ ...n, read: true })) }));
  };

  return <NotificationsContext.Provider value={{ ...state, markRead, refresh }}>{children}</NotificationsContext.Provider>;
}

export const useNotifications = () => useContext(NotificationsContext);
